<template>
    <el-dialog
        class="dose-dialog"
        :title="doseName+'—剂量分析'"
        :visible.sync="show"
        width="800px"
        :before-close="handleClose">
        <div  class="dose-info">
            <div class="dose-tab">
                <p @click='tab_nav(item)' class="tab" :class="tabActive==item.type?'active':''" v-for="(item,index) in doseTab" :key="index">{{item.value}}</p>
            </div>
            <div class="tab-info">
                <div class="info-analysis" v-show='tabActive==1'>
                    <img width="500px" :src="analysisUrl" alt="">
                </div>
                <div v-show='tabActive==2'>
                    <div  class="info" ref="echart_line"> </div>
                </div>
            </div>
        </div>
            <span slot="footer" class="dialog-footer">
        </span>
    </el-dialog>
</template>

<script>
import {jiLiangFenXi,fangCha} from '../../../io/api.js'
export default {
    props: ['show','doseName','doseInfo'],
    data () {
        return {
            doseTab:[
                {
                    value:'剂量分析',
                    type:1
                },
                {
                    value:'剂量分布',
                    type:2
                }
            ],
            tabActive:1,
            myChart:'',
            xName:[],
            seriesData:[],
            analysisUrl:'',
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData(){
            this.getFX();
            this.getFB();
        },
        // 分析
        getFX(){
            let params={
                aveValue:this.doseInfo.aveValue,//	平均剂量	path	false	
                count:1,//	数量，默认1	path	false	
                flValue:this.doseInfo.f1,//	标准差	path	false	
                maxValue:this.doseInfo.maxValue,//		最大剂量	path	false	
                minValue:this.doseInfo.minValue,//		最小剂量	path	false	
                yaoName:this.doseInfo.keyName
            }
            fangCha(params).then(res=>{
                let data = res.data;
                this.analysisUrl = data;
                if(data&&data.code==0){
                }else{ 
                    // this.$message.error(data.msg||'请求失败～');
                }
            })
        },
        // 分布
        getFB(){
            this.xName=[];
            this.seriesData=[];
            jiLiangFenXi({yaoName:this.doseName}).then(res=>{
                let data = res.data;
                if(data&&data.code==0){
                    data.data.infoList.forEach(item=>{
                        this.xName.push(item.keyName);
                        this.seriesData.push(item.valueName)
                    })
                }else{
                    this.$message.error(data.msg||'请求失败～')
                }
            })
            this.$nextTick(() => {
               this.setEcharts_line();
            });
            
        },
        tab_nav(item){
            this.tabActive = item.type;
            if(item.type==2){
                this.setEcharts_line()
            }
        },
        //线图
        setEcharts_line(){
            this.myChart = this.$echarts.init(this.$refs.echart_line,'dark');
            let chartOption ={
                tooltip: {
                    trigger: "item",
                    backgroundColor: "rgba(0,0,0,0.8)",
                    borderColor: '#333',
                    textStyle: {
                        color:'#fff'
                    }
                },
                 xAxis: {
                    type: 'category',
                    data: this.xName
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                    data: this.seriesData,
                    type: 'line'
                    }
                ]
            };
            this.myChart.setOption(chartOption)
        },
        handleClose(){
            this.$emit('update:show',false)
        }
    }
}
</script>

<style lang='less' scoped>
.dose-dialog /deep/ .el-dialog__header{
        line-height: 24px;
        background-color:  #409EFF;
        font-size: 18px;
        padding: 10px 20px;
        .el-dialog__title{
            color: #fff;
        }
    }
 .dose-dialog /deep/  .el-dialog__header{
    line-height: 24px;
    background-color:  #409EFF;
    font-size: 18px;
    padding: 10px 20px;
    .el-dialog__title{
        color: #fff;
    }
}
.dose-dialog /deep/ .el-dialog__headerbtn{
    top:12px;
    .el-dialog__close{
        color: #fff !important;
    }
    
}
.dose-dialog /deep/ .el-dialog__body,.el-dialog__footer{
    // background: #fff !important;
}
.dose-dialog /deep/ .el-dialog__body{
    padding: 20px !important;
}
.dose-dialog /deep/ .el-dialog__footer{
    padding-top: 0;
}
.dose-dialog /deep/ .info{
    width: 700px !important;
    height: 400px !important;
}
   
</style>